import React from 'react';
import { Box, Typography, Avatar, useTheme, Paper } from '@mui/material';

export const ChatMessage = ({ message, isCurrentUser }) => {
    const theme = useTheme();
    
    // Determine background color and text alignment based on sender
    const bgcolor = isCurrentUser 
        ? theme.palette.primary.light // Distinct color for current user
        : theme.palette.background.default; // Default paper color for others
    
    const align = isCurrentUser ? 'flex-end' : 'flex-start';
    const textColor = isCurrentUser ? '#FFFFFF' : theme.palette.text.primary;

    // Simple avatar logic based on sender ID (replace with real user data)
    const senderInitial = message.senderId.charAt(0).toUpperCase();

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                justifyContent: align, 
                mb: 2, 
                width: '100%'
            }}
        >
            {/* Avatar for other users */}
            {!isCurrentUser && (
                <Avatar sx={{ width: 32, height: 32, mr: 1, bgcolor: theme.palette.secondary.main }}>
                    {senderInitial}
                </Avatar>
            )}

            <Box sx={{ maxWidth: '70%', display: 'flex', flexDirection: 'column', alignItems: align }}>
                {/* Sender Name (only for others) */}
                {!isCurrentUser && (
                    <Typography 
                        variant="caption" 
                        sx={{ mb: 0.5, fontWeight: 600, color: theme.palette.text.secondary }}
                    >
                        {message.senderId}
                    </Typography>
                )}

                {/* Message Bubble */}
                <Paper
                    elevation={1}
                    sx={{
                        p: 1.5,
                        borderRadius: 3,
                        borderTopLeftRadius: isCurrentUser ? 3 : 0, // Pointed corner for other users
                        borderTopRightRadius: isCurrentUser ? 0 : 3, // Pointed corner for current user
                        bgcolor: bgcolor,
                    }}
                >
                    <Typography variant="body1" sx={{ color: textColor }}>
                        {message.text}
                    </Typography>
                </Paper>
                
                {/* Timestamp */}
                <Typography 
                    variant="caption" 
                    color="text.secondary" 
                    sx={{ mt: 0.5, opacity: 0.7 }}
                >
                    {message.timestamp}
                </Typography>
            </Box>

            {/* Avatar for current user */}
            {isCurrentUser && (
                <Avatar sx={{ width: 32, height: 32, ml: 1, bgcolor: theme.palette.primary.main }}>
                    {senderInitial}
                </Avatar>
            )}
        </Box>
    );
};